import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=d362abce&scoped=true"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"
import style0 from "./Templates.vue?vue&type=style&index=0&id=d362abce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d362abce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d362abce')) {
      api.createRecord('d362abce', component.options)
    } else {
      api.reload('d362abce', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=d362abce&scoped=true", function () {
      api.rerender('d362abce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/banner-builder/Templates.vue"
export default component.exports